import React, {useState, useEffect} from "react";
import {decodeTokens, FetchElements, GetCookie, updateRefreshToken} from "../../utils/js/request";
import DataUndefaind from "../DataUndifaend/DataUndefaind";
import KpiContainer from "../KPI/kpiContainer/kpiContainer";
import KpiFull from "../KPI/kpiFull/kpiFull";
import {
    UPDATE_SELECTED_SHOP_ID,
    GET_SELECTED_SHOP_ID,
    GET_SELECTED_GROUP_ID,
    UPDATE_SELECTED_GROUP_ID,
    REQUEST,
    GET_ROLE,
    GET_SELECTED_KYST_ID,
    UPDATE_SELECTED_KYST_ID,
    UPDATE_SELECTED_CUST_NAME,
    GET_SELECTED_CUST_NAME,
    UPDATE_SELECTED_SHOP_NAME, GET_SELECTED_SHOP_NAME, UPDATE_CATEGORY_NAME, GET_CATEGORY_NAME,
} from "../../utils/js/Const";
import {NexTitle} from "../../utils/js/UtilsJs";
import {useNavigate} from "react-router-dom";

import "./styleSearch.css";
import CustomAlert from "../../components/CustomAlert/CustomAlert";
import Reload from "../../components/Buttons/ReloadBut/Reload";
import CustomSearch3 from "../../components/CustomSearch2/CustomSearch3";


function SearchContainer({   }) {

    const allowedRoles = [
        "Планограмщик",
        "Обычный Планограмщик",
        "Технолог ГВ",
        "Главный технолог ГВ"
    ];

    NexTitle("Главная")
    let navigate = useNavigate();
    let role = GET_ROLE();

    if (allowedRoles.includes(role)){
        navigate("/PlannogrammList");
    }

    //Полученеи магазинов
    const [accessToken, setAccessToken] = useState(GetCookie("access_token"));
    const [kpis, setKpi] = useState([]);
    const [shops, setShops] = useState([]);
    const [category, setCategory] = useState([]);
    const [kyst, setKyst] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);

    // Стейты для использования АПИ В3
    const [KpiNameId, setKpiNameId] = useState();
    const [expandedKpiDetails, setExpandedKpiDetails] = useState([]);

    const [KustId, setKustId] = useState()
    const [expandedKystDetails, setExpandedKystDetails] = useState([]);

    // Стейты для новых фильтров
    const [kustIdSelect, setKustIdSelect] = useState(GET_SELECTED_KYST_ID() || 0);
    const [kustNameSelect, setKustNameSelect] = useState(GET_SELECTED_CUST_NAME() || "");
    const [shopIdSelect, setShopIdSelect] = useState(GET_SELECTED_SHOP_ID());
    const [shopNameSelect, setShopNameSelect] = useState(GET_SELECTED_SHOP_NAME() || "");
    const [categoryIdSelect, setCategoryIdSelect] = useState(GET_SELECTED_GROUP_ID());
    const [categoryNameSelect, setCategoryNameSelect] = useState(GET_CATEGORY_NAME() || "");

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertStatusCod, setAlertStatusCod] = useState('')

    const handleSetKpiNameId = (id) => {
        setKpiNameId(id);
    };

    const handleSetKystID = (id) => {
        setKustId(id);
    };

    const handleOpenAlert = (title, message, statusCod) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setAlertStatusCod(statusCod);
        setIsOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
    };

    //Новый код для селектов с поиском
    const handel_Select_ID_CUST = (data)=>{
        UPDATE_SELECTED_KYST_ID(data)
        setKustIdSelect(data)
    }
    const handel_Select_NAME_CUST = (data)=>{
        UPDATE_SELECTED_CUST_NAME(data)
        setKustNameSelect(data)
        setShopIdSelect(null)
        setShopNameSelect(null)
        UPDATE_SELECTED_SHOP_ID("")
        UPDATE_SELECTED_SHOP_NAME("")
    }

    const handel_Select_ID_SHOP = (data)=>{
        UPDATE_SELECTED_SHOP_ID(data)
        setShopIdSelect(data)
    }
    const handel_Select_NAME_SHOP = (data)=>{
        UPDATE_SELECTED_SHOP_NAME(data)
        setShopNameSelect(data)
    }

    const handel_Select_ID_CATEGORY = (data)=>{
        UPDATE_SELECTED_GROUP_ID(data)
        setCategoryIdSelect(data)
    }
    const handel_Select_NAME_CATEGORY = (data)=>{
        UPDATE_CATEGORY_NAME(data)
        setCategoryNameSelect(data)
    }

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) {
                const newToken = await updateRefreshToken(setAccessToken,null,()=>{navigate("/")});
                if (newToken) {
                    loadDataKyst();
                    loadDataShops();
                    loadDataGroups();
                    fetchKpiData(newToken);
                    decodeTokens();
                    setDataLoaded(true);
                }
            } else {
                loadDataKyst();
                loadDataShops();
                loadDataGroups();
                fetchKpiData(accessToken)
                decodeTokens();
                setDataLoaded(true);
            }
        };
        fetchData();
    }, [accessToken]);

    const loadDataKyst= () =>{

        FetchElements(
            `${REQUEST}/api/v1/kusts`,
            "GET",
            (data) => {
                setKyst(data);
            },
            () => {
                navigate("/");
            }
        );
    }

    const loadDataShops = () =>{
        FetchElements(
            `${REQUEST}/api/v1/shops?kust_id=${!kustIdSelect ? 1 : kustIdSelect}&shop_id=${!shopIdSelect ? 1 : shopIdSelect}`,
            "GET",
            (data) => {
                setShops(data);
            },
            navigate,
            2,
            () => navigate("/"),
            handleOpenAlert
        );
    }

    const loadDataGroups = () =>{
        FetchElements(
            `${REQUEST}/api/v1/kpi_groups`,
            "GET",
            (data) => {
                setCategory(data);
            },
            navigate,
            2,
            () => navigate("/"),
            handleOpenAlert
        );
    }




    const fetchKpiData = async (token) => {

        if (role === "Админ" || role === "Руководитель"){
            if (categoryIdSelect > 0) {
                FetchElements(`${REQUEST}/api/v3/kpi?group_id=${categoryIdSelect}`,"GET", setKpi, navigate,2,() => navigate("/"),handleOpenAlert);
            }
        }else if (role === "Кустовой" || role === "Учебный центр"){
            if (categoryIdSelect > 0) {
                FetchElements(`${REQUEST}/api/v3/kpi?group_id=${categoryIdSelect}&kust_id=${!kustIdSelect ? 0 : kustIdSelect}`,"GET", setKpi, navigate,2,() => navigate("/"),handleOpenAlert);
            }
        }else{
            if (shopIdSelect > 0 && categoryIdSelect > 0) {
                FetchElements(`${REQUEST}/api/v3/kpi?shop_id=${shopIdSelect}&group_id=${categoryIdSelect}`,"GET", setKpi, navigate,2,() => navigate("/"),handleOpenAlert);
            }
        }

    };





    //Метод который подходит для получения данных по kpi_name_id ДЛЯ КУСТОВОГО и учебного центра
    const getKpiShops = async (token) => {
        if (role === "Кустовой" || role === "Учебный центр"){
            try {
                const response = await fetch(
                    `${REQUEST}/api/v3/kpi?group_id=${categoryIdSelect}&kust_id=${!kustIdSelect ? 0 : kustIdSelect}&kpi_name_id=${KpiNameId}`,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            "access-token": token
                        },
                    }
                );

                if (!response.ok) {
                    const data = await response.json();
                    throw new Error(`${data.message}, код: ${response.status}`);
                }

                const data = await response.json();

                if (response.ok) {
                    const newDetailsArray = data.data.kpi.map(item => ({
                        ...item,
                        id: KpiNameId
                    }));

                    setExpandedKpiDetails(prevState => [...prevState, ...newDetailsArray]);
                }
            } catch (error) {
                handleOpenAlert('Ошибка', `${error.message || "Ошибка при получение данных"}`);
                return;
            }
        }
    };

    //Метод который подходит для получения данных по kpi_name_id ДЛЯ Администратора и руководителя
    const getKpiAllKyst = async (token) => {
        if (role === "Админ" || role === "Руководитель"){
            try {
                const response = await fetch(
                    `${REQUEST}/api/v3/kpi?group_id=${categoryIdSelect}&kpi_name_id=${KpiNameId}`,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            "access-token": token
                        },
                    }
                );

                if (!response.ok) {
                    const data = await response.json();
                    throw new Error(`${data.message}, код: ${response.status}`);
                }

                const data = await response.json();

                if (response.ok) {
                    const newDetailsArray = data.data.kpi.map(item => ({
                        ...item,
                        _id: KpiNameId
                    }));

                    setExpandedKpiDetails(prevState => [...prevState, ...newDetailsArray]);
                }
            } catch (error) {
                handleOpenAlert('Ошибка', `${error.message || "Ошибка при получение данных"}`);
                return;
            }
        }
    };

    //Метод который подходит для получения данных по kpi_name_id ДЛЯ Администратора и руководителя
    const getKystData = async (token) => {
        if (role === "Админ" || role === "Руководитель"){
            try {

                const response = await fetch(
                    `${REQUEST}/api/v3/kpi?group_id=${categoryIdSelect}&kust_id=${KustId}&kpi_name_id=${KpiNameId}`,
                    {
                        method: 'GET',
                        headers: {
                            'Accept': 'application/json',
                            "access-token": token
                        },
                    }
                );

                if (!response.ok) {
                    const data = await response.json();
                    throw new Error(`${data.message}, код: ${response.status}`);
                }

                const data = await response.json();

                if (response.ok) {
                    const newDetailsArray = data.data.kpi.map(item => ({
                        ...item,
                        _id: KustId
                    }));

                    setExpandedKystDetails(prevState => [...prevState, ...newDetailsArray]);
                }
            } catch (error) {
                handleOpenAlert('Ошибка', `${error.message || "Ошибка при получение данных"}`);
                return;
            }
        }
    };

    // Этот useEffect будет загружать данные при изменении выбранного куста
    useEffect(() => {
        if (dataLoaded){
            loadDataShops();
            /*loadDataGroups();*/
            fetchKpiData(accessToken);
        }
    }, [kustIdSelect])

    // Этот useEffect будет загружать данные при изменении выбранного магазина
    useEffect(() => {
        if (dataLoaded){
            loadDataGroups();
            fetchKpiData(accessToken);
        }
    }, [shopIdSelect])

    // Этот useEffect будет загружать данные при изменении выбранной категории
    useEffect(() => {
        if (dataLoaded){
            fetchKpiData(accessToken);
        }
    }, [categoryIdSelect])

    // Этот useEffect будет загружать данные при изменении выбранной категории Для кустового
    useEffect(() => {
        if (dataLoaded){
            if (role === "Кустовой" || role === "Учебный центр"){
                getKpiShops(accessToken);
            }else{
                getKpiAllKyst(accessToken);
            }
        }
    }, [KpiNameId])

    // Этот useEffect будет загружать данные при изменении выбранной категории Для Админа для получения данных по кусту
    useEffect(() => {
        if (dataLoaded){
            getKystData(accessToken);
        }
    }, [KustId]);

    return(
        <>
            {(accessToken !== null) ? (
                <>
                    <CustomAlert
                        title={alertTitle}
                        message={alertMessage}
                        statusCod={alertStatusCod}
                        isOpenAlert={isOpenAlert}
                        onClose={handleCloseAlert}
                    />
                    <nav className={`search--container max--width--control`}>
                        <CustomSearch3 name={"Куст"}
                                       data={kyst}
                                       idSelectedItem={handel_Select_ID_CUST}
                                       dropdown_wrapper_modifikator={"SerachConteinerMode"}
                                       dropdown_header_modifikator={`headerMode`}
                                       selected={handel_Select_NAME_CUST}
                                       initialValue={kustNameSelect}
                        />
                        <CustomSearch3 name={"Магазин"}
                                       data={shops}
                                       idSelectedItem={handel_Select_ID_SHOP}
                                       dropdown_wrapper_modifikator={"SerachConteinerMode"}
                                       dropdown_header_modifikator={`headerMode`}
                                       selected={handel_Select_NAME_SHOP}
                                       initialValue={shopNameSelect}
                        />
                        <CustomSearch3 name={"Категория"}
                                       data={category}
                                       idSelectedItem={handel_Select_ID_CATEGORY}
                                       dropdown_wrapper_modifikator={"SerachConteinerMode"}
                                       dropdown_header_modifikator={`headerMode`}
                                       selected={handel_Select_NAME_CATEGORY}
                                       initialValue={categoryNameSelect}
                        />

                        <Reload classModificator={"modificatorBlocka"}/>
                    </nav>

                    <div id="MAINKPI">
                        {
                            (role === "Админ" || role === "Кустовой" || role === "Руководитель" || role === "Учебный центр") ?
                                <>
                                    {
                                        (!kustIdSelect || !shopIdSelect || !categoryIdSelect) ? (
                                            <DataUndefaind text={`Для получения данных, выберите куст, магазин и категорию...`} />
                                        ) : (
                                            <KpiFull
                                                kpi_data={kpis.kpi}
                                                onKpiNameChange={handleSetKpiNameId}
                                                onKystIdChange={handleSetKystID}
                                                expandedKpiDetails={expandedKpiDetails}
                                                expandedKystDetails={expandedKystDetails}
                                                role={role}
                                            />
                                        )
                                    }
                                </>
                                :
                                <>
                                    {(!kustIdSelect || !shopIdSelect || !categoryIdSelect) ? (
                                        <DataUndefaind text={`Для получения данных, выберите куст, магазин и категорию...`} />
                                    ) : (
                                        <KpiContainer {...kpis} classname="max--width--control" />
                                    )}
                                </>
                        }
                    </div>
                </>
            ) : (
                <div></div>
            )}
        </>
    );
}
export default SearchContainer;